import OneTimeContractModal from './OneTimeContractModal';

export default OneTimeContractModal;
